// style.js
import { styled } from '@mui/material/styles';

/* Label that changes color when checked */
export const Label = styled('span')(({ theme, checked }) => ({
  ...(checked && {
    color: theme.color.primary.main
  })
}));

/* Switch background box */
export const SwitchBox = styled('div')(({ theme }) => ({
  backgroundColor: theme.color.grey[200],
  border: `1px solid ${theme.color.grey[500]}`,
  boxSizing: 'border-box',
  borderRadius: '0.75em',
  display: 'flex',
  height: '1.5em',
  padding: '0.125em',
  width: '2.75em'
}));

/* Wrapping label that handles layout + disabled state */
export const WrappingLabel = styled('label')(({ theme, disabled }) => ({
  alignItems: 'center',
  display: 'flex',
  fontSize: '1em',
  justifyContent: 'flex-end',
  cursor: 'pointer',

  [`${Label} + ${SwitchBox}, ${SwitchBox} + ${Label}`]: {
    marginLeft: '0.5em'
  },

  ...(disabled && {
    color: theme.color.disabled.text,
    cursor: 'default',
    [`${Label}`]: {
      color: theme.color.disabled.text
    }
  })
}));

/* Handle (the round knob) */
export const SwitchHandle = styled('div')(({ theme }) => ({
  background: theme.color.primary.contrast,
  boxShadow: theme.boxShadow.base,
  borderRadius: '50%',
  height: '1.125em',
  width: '1.125em',
  transition: `all ${theme.animation.standard}`,
  transitionProperty: 'transform'
}));

/* Hidden checkbox that drives the switch */
export const StyledSwitch = styled('input')(({ theme }) => ({
  display: 'none',

  '&:checked ~ div': {
    background: theme.color.primary.gradient,
    borderColor: 'transparent',

    [`${SwitchHandle}`]: {
      transform: 'translateX(1.25em)'
    }
  },

  '&:disabled ~ div': {
    background: theme.color.grey[400],
    borderColor: 'transparent',

    [`${SwitchHandle}`]: {
      boxShadow: 'none'
    }
  }
}));

StyledSwitch.defaultProps = {
  type: 'checkbox'
};
